import BliIconSiHome from '@blibli/blue-dls-library-icon/dist/Home'
import BliIconSiScan from '@blibli/blue-dls-library-icon/dist/Scan'
import BliIconSiOrder from '@blibli/blue-dls-library-icon/dist/Order'
import BliIconSiCashOut from '@blibli/blue-dls-library-icon/dist/CashOut'
import BliIconSiMultiProduct from '@blibli/blue-dls-library-icon/dist/MultiProduct'
import BliIconSiSetting from '@blibli/blue-dls-library-icon/dist/Setting'
import BliIconSiNotification from '@blibli/blue-dls-library-icon/dist/Notification'
import CommonMixin from '@vue3/mixins/commonMixin.js'
import { markRaw } from 'vue'
import { pages, app } from '@vue3/configs'
import CommonStore from '@vue3/store/common-store.js'
import RewardsStore from '@vue3/store/rewards-store.js'
import { mapState } from 'pinia'
import NotificationModal from '@vue3/components/common/NotificationModal/index.vue'
import BliBadge from '@blibli/blue.badge/dist/badge/blue/Badge'

export default {
  name: 'NavigationBar',
  components: {
    BliIconSiScan,
    BliIconSiHome,
    BliIconSiOrder,
    BliIconSiCashOut,
    BliIconSiSetting,
    BliIconSiMultiProduct,
    BliIconSiNotification,
    NotificationModal,
    BliBadge
  },
  data () {
    return {
      activeTab: 'home',
      tabs: [
        { label: this.$t('navBar.home'), icon: markRaw(BliIconSiHome), url: pages.homePage, name: app.routerName.homePage },
        { label: this.$t('navBar.catalog'), icon: markRaw(BliIconSiMultiProduct), url: pages.catalog, name: app.routerName.catalog },
        { label: this.$t('navBar.orders'), icon: markRaw(BliIconSiOrder), url: pages.orderList, name: app.routerName.orderList },
        { label: this.$t('navBar.sales'), icon: markRaw(BliIconSiCashOut), url: pages.rewards, name: app.routerName.rewards }
      ],
      showNotificationModal: false
    }
  },
  mixins: [CommonMixin],
  mounted () {
    this.activeTab = this.getSelectedTab()
    this.observeIosTabChange()
    if (this.isDesktop) {
      this.getEngagementInfo({
        param: { email: this.userDetails.email }
      })
    }
  },
  watch: {
    $route () {
      this.activeTab = this.getSelectedTab()
    }
  },
  computed: {
    ...mapState(CommonStore, ['showOnboardingModal']),
    ...mapState(RewardsStore, ['getEngagementInfo']),
    path () {
      return this.$route.path
    }
  },
  methods: {
    selectThisTab (item) {
      const { url } = item
      if (this.path === url) return
      if (this.isIOSApp && url === pages.rewards) {
        this.postMessageToIOSListener('OPEN_SCAN_IMEI')
      }
      this.$router.push(url)
    },
    observeIosTabChange () {
      if (!this.isIOSApp) {
        return
      }
      window.onTabChanged = (tabName) => {
        switch (tabName) {
          case 'HOME':
            this.$router.push({ path: pages.homePage })
            break
          case 'CATALOG':
            this.$router.push({ path: pages.catalog })
            break
          case 'ORDER_LIST':
            this.$router.push({ path: pages.orderList })
            break
          default:
            this.$router.push({ path: pages.homePage })
        }
      }
    },
    getSelectedTab () {
      const headerTabGroup = this.$route.meta?.headerTabGroup
      return headerTabGroup ? (this.tabs.find(tab => tab.name === headerTabGroup)?.name) : this.$route.name
    },
    toggleNotificationModal () {
      if (this.$route.name === app.routerName.notification) {
        return
      }
      this.showNotificationModal = !this.showNotificationModal
    }
  },
  beforeUnmount () {
    window.onTabChanged = null
  }
}
